import React, {useContext} from 'react';
import { Context } from '../../commons/context';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

const SliderComponent = ({onChangeFnc}) => {
  const [data] = useContext(Context);

  return (
        <Slider
            min={0}
            max={2}
            defaultValue={data.slider}
            marks={{ 0: 'Area', 1: 'Dealer group', 2: 'Dealer' }}
            onChange={onChangeFnc}
        />
  )
};

export default SliderComponent;
